import { Component, OnDestroy } from '@angular/core';
import {ApiService} from '../shared/api.service';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'disclosures',
    templateUrl: 'disclosures.component.html'
})
export class DisclosuresComponent implements OnDestroy {
    disclosureText = '';
    canEdit = false;
    disclosuresEditor = '';
    error = '';
    heartbeatSubscription;
    loading = false;
    saved = false;
    placeholder = 'This article may contain affiliate links and/or offers from our affiliate partners. Clicking on a link and/or completing an offer may result in a portion of proceeds from each transaction being paid to [site].';
    inputSubscription;
    textareaControl = new FormControl();
    loaded = false;
    
    constructor(private api: ApiService) {
        const user = this.api.getProp('user');
        if( user.role == 'administrator' || user.role == 'editor' ) {
            this.canEdit = true;
        }
        if( this.canEdit ) {
            this.checkLock(false);
            this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
                this.checkLock(false);
            });
        }
        this.disclosureText = this.api.getProp('affiliateDisclosure');
        this.textareaControl.setValue(this.disclosureText);
        this.inputSubscription = this.textareaControl.valueChanges.pipe(
            debounceTime(250)
        ).subscribe(value => {
            if( value ) {
                this.disclosureText = value;
            }
            if( this.loaded ) {
                this.save();
            }
            this.loaded = true;
        });
    }
    checkLock(takeover) {
        this.api.doAction('post', 'disclosures', {
            action: 'check_lock'
        }).subscribe(
            data => {
                if( data.locked && !takeover ) {
                    this.disclosuresEditor = data.disclosuresEditor;
                }
                if( takeover || !data.locked ) {
                    this.setLock('update');
                }
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        );
    }
    setLock(action) {
        this.resetError();
        this.loading = true;
        this.api.doAction('post', 'disclosures', {
            action: 'set_lock',
            lockAction: action
        }).subscribe(
            data => {
                if( action == 'update' ) {
                    this.disclosuresEditor = '';
                }
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    triggerSaveMessage() {
        this.saved = true;
        setTimeout(() => {
            this.saved = false;
        }, 3000);
    }
    resetError() {
        this.error = '';
        this.saved = false;
    }
    save() {
        this.api.doAction('post', 'disclosures', {
            action: 'update',
            text: this.disclosureText
        }).subscribe(
            data => {
                if( data.disclosuresEditor ) {
                    this.disclosuresEditor = data.disclosuresEditor;
                    return;
                }
                this.api.setProp('affiliateDisclosure', this.disclosureText);
                this.triggerSaveMessage();
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    ngOnDestroy() {
        this.setLock('delete');
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
        if( this.inputSubscription ) {
            this.inputSubscription.unsubscribe();
        }
    }
}